<template>
  <div
    v-if="!blok.visualAppearance?.loggedInOnly || userStore.isLoggedIn || isInStoryblokAdmin()"
    class="SpaceHandler"
    :class="[spacingClasses, backgroundColor]"
  >
    <div
      v-if="blok.visualAppearance?.loggedInOnly && isInStoryblokAdmin()"
      class=" border border-border-errorStrong bg-bg-error p-4"
    >
      <img
        alt=""
        src="/icons/warning.svg"
        class="inline-block h-20 w-20 mr-8"
      > Shown to logged in users only
    </div>
    <div
      ref="observerEl"
      :class="[fadeIn]"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * It seems we can't type this since storyblok thinks it's an SbDataBlok
 */
import { useUserStore } from '~/store/user';
import { useGlobalContentStore } from '~/store/globalContent';
import useStoryblokAdmin from '~/composables/useStoryblokAdmin';

const { isInStoryblokAdmin } = useStoryblokAdmin();

const props = defineProps<{
  blok: any,
}>();

const userStore = useUserStore();
const globalContentStore = useGlobalContentStore();

const spacingClasses = computed(() => {
  const output = [];
  if (props.blok?.visualAppearance?.spacing) {
    output.push(props.blok.visualAppearance.spacing);
  } else {
    output.push('spacing-base');
  }
  return output;
});

const backgroundColor = computed(() => {
  const output = [];
  if (props.blok?.visualAppearance?.backgroundColor) {
    let bg = props.blok.visualAppearance.backgroundColor;
    if (bg === 'bg-bg-emphasisSubtle' && !globalContentStore.getIsNonEcomSite) {
      bg = 'bg-bg-subtle';
    }
    output.push(bg);
  } else {
    output.push('bg-base');
  }
  return output;
});

const fadeIn = computed(() => {
  const output = [];
  if (!isInStoryblokAdmin() && props.blok?.visualAppearance?.fade_type?.length) {
    output.push(props.blok?.visualAppearance?.fade_type.replaceAll('_', '-'));
  }
  return output;
});

const observerEl = ref(null);

onMounted(() => {
  if (observerEl.value && !isInStoryblokAdmin() && props.blok?.visualAppearance?.fade_type?.length) {
    const observerOptions = {
      root: null,
      threshold: 0,
      rootMargin: '-100px',
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('observer-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    observer.observe(observerEl.value as unknown as Element);
    onBeforeUnmount(() => {
      observer.unobserve(observerEl.value as unknown as Element);
    });
  }
});

</script>
